import { render, staticRenderFns } from "./AddLinkToNumber.vue?vue&type=template&id=349f4b98&"
import script from "./AddLinkToNumber.vue?vue&type=script&lang=js&"
export * from "./AddLinkToNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports